import React from 'react';

export function InputDouble (props) { 
  return ( 
    <label className='form__label_limit'>
       <input
          type="number"
          id={`${props.id}-min`}
          name={`${props.id}-min`}
          min={Math.round(props.minedge)}
          max={Math.round(props.maxedge)}
          placeholder={Math.round(props.minedge)}
          value={props.minValue} 
          className={`form__input form__input_limit font20Norm`}
          onChange={props.onChange}
          onBlur={props.calsClick}
        /> 
      
       <input
          type="number"
          id={`${props.id}-max`}
          name={`${props.id}-max`}
          min={Math.round(props.minedge)}
          max={Math.round(props.maxedge)}
          placeholder={Math.round(props.maxedge)}
          value={props.maxValue} 
          className={`form__input form__input_limit font20Norm`}
          onBlur={props.calsClick}
          onChange={props.onChange}
        /> 
       
       {props.error && <span className="form__text_error font14Norm">{props.error}</span>}
       </label>
  )        
}
  